import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const useFetchUsageDetailsEffect = ({
    myCaseRefId,
    myCaseResourceType,
    usageDetails,
    orderStatusDescription,
    orderBasicDetails,
    dispatch,
    resetLevelData,
    fetchUsageDetailsRequest,
    getDropdownOptionsRequest,
    reportPaymentClick,
    reportPaymentClicked
}) => {
    useEffectWithErrorLogging(() => {
        if (
            myCaseRefId &&
            myCaseResourceType &&
            usageDetails?.myCaseRef !== myCaseRefId &&
            orderStatusDescription != undefined
        ) {
            dispatch(resetLevelData());
            dispatch(
                fetchUsageDetailsRequest({
                    resourceType: myCaseResourceType,
                    myCaseRef: myCaseRefId,
                })
            );
            dispatch(getDropdownOptionsRequest('accountLookup'));
            dispatch(reportPaymentClicked(false));
        }
    }, [
        myCaseRefId,
        myCaseResourceType,
        orderStatusDescription,
        orderBasicDetails,
        reportPaymentClick
    ]);
};